import React from "react";
import { styled } from "styled-components";
import "./Home.css";

// ${(props) => props.$animation_delay}

const animated_span = styled.span``;

const wordsPerSecond = 6;

function getProperties(index) {
  return {
    animation: `fade-in 0.8s ${
      (index * 1) / wordsPerSecond
    }s forwards cubic-bezier(0.11, 0, 0.5, 0)`,
  };
}

function getAuthorProperties(index) {
  return {
    animation: `fade-in 0.8s ${
      (index * 1) / wordsPerSecond + 0.75
    }s forwards cubic-bezier(0.11, 0, 0.5, 0)`,
  };
}

const MainPageQuotes = ({ text, author, style = {} }) => {
  const myText = text.split(" ");

  return (
    <div className="mainQuote" style={style}>
      <p>
        {myText.map((word, index) => (
          <span key={index} style={getProperties(index)}>
            &nbsp;{word}
          </span>
        ))}
      </p>
      <p className="author" style={getAuthorProperties(myText.length)}>
        {" "}
        - {author} -
      </p>
    </div>
  );
};

export default MainPageQuotes;
